import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { LocalStorageService } from './core/services/common/local-storage.service';
import { AntiforgerytokenService } from './core/services/login/antiforgerytoken.service';
import { ServersideAlertService } from './core/services/onboarding/serverside-alert.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Client Onboarding';
  tokenValue: string;
  tokenName: string;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'large',
  };
  rootId = '';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private ls: LocalStorageService,
    private ssas: ServersideAlertService,
    private as: AntiforgerytokenService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef
  ) {
    this.rootId =
      this.sanitizer.sanitize(
        SecurityContext.HTML,
        this.elementRef.nativeElement.getAttribute('client-dashboard')
      ) ?? '';
    console.log('rootId, ', this.rootId);
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.ssas.dereport();
      }
    });
  }

  ngAfterViewInit() {
    const tokenElement = this.document.getElementsByName(
      '__RequestVerificationToken'
    )[0] as HTMLInputElement;
    this.tokenValue = tokenElement.value;
    this.tokenName = tokenElement.name;
    this.as.antiForgeryToken = this.tokenValue;
  }
}
